import { Dispatch, MutableRefObject } from 'react'
import { Icons } from '../assets/icons'
import { CATS, VALUES, DIMENSIONS_TYPE, CATS_TYPE } from '../utils/values/cats'
import { DEFAULT_ASGN_STATE, DEFAULT_AUTH_STATE, DEFAULT_GLOBAL_STATE, FSM_STATE_TYPE } from './defaultState'
import { FixedArray } from '../utils/types'
import { PartialParameters } from '../parameters/types'
import { SaveSessionProps, SessionData } from './session/types'
import { AnswserScoreType } from '../services/types'

// FIXME duplicated
export type STM = {
    id: number
    title: string
    //
    valueKey?: string //FIXME for later refactoring

    //
    title_360_leadership?: string //FIXME clean this later
    title_360_workenv?: string //FIXME clean this later
    preferredType: 'leadership' | 'workenv' | 'disabled'
}

export type Stm = {
    id: string
    title: string
    category?: CATS_TYPE
    valueKey?: VALUES
    // FIXME use in phase 2
    dimensionKey?: DIMENSIONS_TYPE
}

export const UNASSIGNED = -1 as const;
export const RANKED_BEST = 9 as const; // For refs ! TODO unit test
export const RANKED_WORST = 1 as const; // For refs ! TODO unit test
export type RANKING = typeof UNASSIGNED | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9
export interface Assignation extends Stm {
    // FIXME remove index, ranking?
    index: number // index in the shuffled and filtered deck // FIXME is a ranking ?
    weight?: number
    ranking?: RANKING // ranking in the shuffled and filtered deck FIXME is a bucket ?
    bucket?: RANKING | number // bucket in the shuffled and filtered deck
    roundNumber?: number
    // ==== // FIXME refactor for UI purpose:
    highlight?: boolean
    selected?: boolean
    valueKey: VALUES
    //
    preferredType360: STM['preferredType']
    // use for qsortV2 for unseen stms
    diversityScore?: number
}

export type BUTTON_TYPE = {
    disabled?: boolean //  FIXME refacto
    label: string
    color:
        | 'inherit'
        | 'primary'
        | 'secondary'
        | 'success'
        | 'error'
        | 'info'
        | 'warning'
    Icon?: typeof Icons.SvgIcon
    variant?: 'text' | 'outlined' | 'contained'
    onClick?: () => void // disabled
}

export type TernaryComparison<T> = [T, T, T?]
export type CompareTernary<T> = (
    { a, b, c }: { a: T; b: T; c?: T },
    step: number,
    current: T
) => Promise<TernaryComparison<T>>

export type CompareBinary<T> = (
    { a, b }: { a: T; b: T },
    step: number,
    current: T
) => Promise<boolean>

export type InsertionData = {
    id: string
    index: number
}

export type SearchParams<T, N extends number> = {
    asgnsLeft2Rank: T[]
    asgnsRanked: T[]
    currentStep: number // currentStmIndex +1
    maxComparedSize: N
    compareNAry: CompareNAry<T, N>, // includes Binary
    setAndSaveSessionData: CommonValueType['setAndSaveSessionData']
    currentRoundIndex: number
}

export const GO_BACK_INDEX = -1 as const
export type GO_BACK_INDEX_TYPE = typeof GO_BACK_INDEX
export type CompareNAry<T, N extends number> = (
    element: T,
    input: FixedArray<T, N>,
    step: number
) => Promise<number | GO_BACK_INDEX_TYPE>

export type AsgOrPlaceholder = Assignation | null

export type GLOBAL_STATE_TYPE = typeof DEFAULT_GLOBAL_STATE

export type ResetFN =  (options?: {
    fsmState: FSM_STATE_TYPE,
    newParams?: PartialParameters,
    loginState?: typeof DEFAULT_AUTH_STATE
}) => void // FIXME

export type GlobalActionsTypes = {
    toggleDrawer: any //(anchor: Anchor) => (event: MouseEvent | KeyboardEvent ) => void;
    toggled: any // boolean
    handleDrag: any // (t:any) => void;
    resetFn: ResetFN
    incrWeight: (id: string) => void
    decrWeight: (id: string) => void
    setGlobalState:  Dispatch<React.SetStateAction<GLOBAL_STATE_TYPE>>
}

export type AsgnStateType = typeof DEFAULT_ASGN_STATE
export type AsgnState = {
    state: AsgnStateType
    sessionData: SessionData
    // 
    rounds: Assignation[][]
    // 
    scannedItems: AnswserScoreType[]
    allStms?: Record<STM['preferredType'], Assignation[]> // cache for 360 FIXME
    // temps data
    asgnsForRound: Assignation[]
    items2compare: Assignation[] // both for binary and n-ary...
    items2rank: Assignation[] // rank for round
    index2submit: number
    asgnsLeft2Rank: MutableRefObject<Assignation[]>
    asgnsRanked: MutableRefObject<Assignation[]>
} //& AsgnStateType

export type AsgnStateActions = {
    resetAsgnState: (
        fsmState?: FSM_STATE_TYPE,
        newParams?: PartialParameters,
        loginState?: typeof DEFAULT_AUTH_STATE
    ) => void
    //  FIXME
    setState: Dispatch<React.SetStateAction<AsgnStateType>>
    setRounds: Dispatch<React.SetStateAction<Assignation[][]>>
    setAsgnsForRound: Dispatch<React.SetStateAction<Assignation[]>>
    setItems2compare: Dispatch<React.SetStateAction<Assignation[]>>
    setItems2rank: Dispatch<React.SetStateAction<Assignation[]>>
    setSessionData: Dispatch<React.SetStateAction<SessionData>>
    setIndex2submit: Dispatch<React.SetStateAction<number>>
    setScannedItems: Dispatch<React.SetStateAction<AnswserScoreType[]>>
} & SaveSessionProps
export type AsgnFullTypes = AsgnState & AsgnStateActions

export type FSM_ACTIONS_TYPE = {
    isRunning?: boolean
    hasTopTitle?: boolean
    topTitle?: string
    topSubtitle?: string
    topLeft?: BUTTON_TYPE
    topCenter?: BUTTON_TYPE
    topRight?: BUTTON_TYPE
    topTooltip?: string
    hasBottomNav?: boolean
    hasProgress?: boolean
    bottomLeft: BUTTON_TYPE
    bottomCenter?: BUTTON_TYPE
    bottomRight: BUTTON_TYPE
    // 
    onSortRoundComplete?: (sortedArray: Assignation[]) => void
    onRankBucketComplete?: (buckets: Assignation[][]) => void
}

export type CommonValueType = FSM_ACTIONS_TYPE &
    AsgnFullTypes &
    GlobalActionsTypes & GLOBAL_STATE_TYPE;
  
// FIXME refactor    
export type CommonValueTypeTODO = {
    state: AsgnStateType
    fsmData : FSM_ACTIONS_TYPE
    globalData: GLOBAL_STATE_TYPE
    asgData: Omit<AsgnState, 'state' | 'sessionData'>
    sessionData: SessionData
    actions: AsgnStateActions & GlobalActionsTypes
} 